import script from "./CabeceraMovil.vue?vue&type=script&setup=true&lang=js"
export * from "./CabeceraMovil.vue?vue&type=script&setup=true&lang=js"

import "./CabeceraMovil.vue?vue&type=style&index=0&id=33a73812&lang=scss"

const __exports__ = script;

export default __exports__